export enum FedopsInteraction {
  OpenPaymentPage = 'open-payment-widget',
  JoinUserToChallenge = 'join-to-challenge',
}
